import type { Property } from "@/types/realEstate";
import { PropertyCatalog } from "./PropertyCatalog";

export default {
  list: PropertyCatalog,
  recordRepresentation: (record: Property) =>
    `${record?.unit_number} (${record?.configuration})`,
};
